import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const buyers = [{
  name: 'María',
  city: 'Buenos Aires'
}, {
  name: 'Florencia',
  city: 'Córdoba'
}, {
  name: 'Julieta',
  city: 'Rosario'
}, {
  name: 'Ana',
  city: 'Mendoza'
}, {
  name: 'Sofía',
  city: 'La Plata'
}, {
  name: 'Lucía',
  city: 'Tucumán'
}, {
  name: 'Valentina',
  city: 'Neuquén'
}, {
  name: 'Camila',
  city: 'Mar del Plata'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showPopup = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setBuyer(randomBuyer);
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 4000);
      const nextDelay = Math.floor(Math.random() * 5000) + 15000;
      setTimeout(showPopup, nextDelay);
    };
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-up" data-id="element-231">
      <div className="bg-white rounded-lg shadow-lg p-4 flex items-center gap-4 border-l-4 border-green-500 max-w-xs" data-id="element-232">
        <div className="bg-green-100 p-2 rounded-full" data-id="element-233">
          <CheckCircle className="w-6 h-6 text-green-600" data-id="element-234" />
        </div>
        <div data-id="element-235">
          <p className="text-sm font-bold text-gray-900" data-id="element-236">
            {buyer.name} de {buyer.city}
          </p>
          <p className="text-xs text-gray-600" data-id="element-237">acaba de comprar el MegaPack</p>
          <p className="text-[10px] text-gray-400 mt-1" data-id="element-238">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}